var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-con",on:{"click":_vm.showMessage}},[_c('Tooltip',{attrs:{"content":_vm.value > 0 ? '有' + _vm.value + '条未读消息' : '无未读消息',"placement":"bottom"}},[_c('Badge',{attrs:{"count":_vm.value,"class-name":"demo-badge-alone"}},[_c('Icon',{attrs:{"type":"ios-chatboxes-outline","size":22}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }